<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...$$props}>
  <g clip-path="url(#clip0_8086_324)">
    <path
      d="M16 8.00002C16 3.58174 12.4183 1.81198e-05 8 1.81198e-05C3.58172 1.81198e-05 0 3.58174 0 8.00002C0 11.993 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8.00002H6.75V6.23752C6.75 4.23252 7.94434 3.12502 9.77172 3.12502C10.647 3.12502 11.5625 3.28127 11.5625 3.28127V5.25002H10.5537C9.55992 5.25002 9.25 5.86669 9.25 6.49935V8.00002H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8.00002Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_8086_324">
      <rect width="16" height="16" fill="currentColor" />
    </clipPath>
  </defs>
</svg>
